<template>
    <svg class="icon" :style="extraStyling"><use :xlink:href="id" /></svg>
</template>

<style lang="scss">
  @keyframes rotate {
    0%   { transform: rotate(0deg) }
    100% { transform: rotate(360deg) }
  }
  .icon {
    width: 1em;
    height: 1em;
    fill: currentColor;
    vertical-align: middle;
    align-self: center;
    line-height: 1em;
  }
</style>

<script>
// Import all icons from public/icons folder
var req = require.context('@/../public/icons', true, /\.svg$/)
req.keys().forEach(function(key) {
	req(key)
})

export default {
	name: 'icon',
	props: {
		name: {
			type: String,
			required: true
		},
		color: {
			type: String,
			required: false
		},
		size: {
			required: false
		},
		direction: {
			type: String,
			required: false
		},
		animation: {
			type: Object,
			required: false
		}
	},
	computed: {
		id() {
			return '#' + this.name
		},
		extraStyling() {
			var styling = {}
			if (this.color) {
				styling['fill'] = this.color
			}
			if (this.size) {
				if (typeof this.size === 'object') {
					styling['width'] = this.size.width
					styling['height'] = this.size.height
				} else {
					styling['width'] = this.size
					styling['height'] = this.size
				}
			}
			if(this.direction){
				switch(this.direction){
				case 'down':
					styling['transform'] = 'rotate(180deg)'
					break
				case 'left':
					styling['transform'] = 'rotate(-90deg)'
					break
				case 'right':
					styling['transform'] = 'rotate(90deg)'
					break
				default:
					styling['transform'] = ''
					break
				}
			}
			if(this.animation){
				var a = this.animation
				var animation = `${a.name} ${a.duration} ${a.repeat} linear`
				styling['animation'] = animation
			}
			return styling
		}
	},
	data() {
		return {}
	}
}
</script>